export default "__VITE_ASSET__f53346cd__"